

export const redirectTo = (url) => {
    if( typeof window !== "undefined") {
        window.location.assign(url);
    }
}

export const getOrigin = () => {
    if( typeof window !== "undefined") {
        return window.location.origin;
    }
}

export const getQueryString = () => {
    if ( typeof window !== "undefined") {
        return window.location.search;
    }
    return "";
}

export const xhr = (url, options) => {
    if ( typeof window !== "undefined") {
        return window.fetch(url, options)
    }
    return null
}